import type { BulkOperationItem } from '@/school-management/types/services/bulk';

/** Bulk APIs may use `itemId` (students) or `groupId` (classes). */
export function getBulkOperationEntryId(item: BulkOperationItem): string | undefined {
  const rec = item as Record<string, unknown>;
  if (typeof rec.itemId === 'string' && rec.itemId.trim()) return rec.itemId.trim();
  if (typeof rec.groupId === 'string' && rec.groupId.trim()) return rec.groupId.trim();
  return undefined;
}

export function getBulkOperationEntrySuccess(item: BulkOperationItem): boolean {
  return typeof (item as { success?: boolean }).success === 'boolean'
    ? Boolean((item as { success: boolean }).success)
    : false;
}
